export default __webpack_public_path__ + "static/media/ferrari.918e0de1.png";